import React, {PureComponent} from "react"

import {Input} from "@irati/ui/src/FormItem"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Validation from "@irati/utils/validation"
import {IconWrapper} from "./styled"

const PASSWORD = "password"
const ENTER_YOUR_PASSWORD = "platform.password.validation.enterPassword"

interface Props {
  onChange: (value: string) => void,
  value?: string,
  passwordToMatch?: string,
  label?: string,
  name?: string,
  placeholder?: string,
  noValidation?: boolean,
  isRequired?: boolean
}

interface State {
  capsLockOn?: boolean,
  showPassword: boolean
}

class Password extends PureComponent<Props, State> {
  static defaultProps = {
    value: null,
    label: ENTER_YOUR_PASSWORD,
    name: PASSWORD,
    placeholder: ENTER_YOUR_PASSWORD,
    passwordToMatch: null,
    noValidation: false,
    isRequired: false
  }

  state: State = {
    capsLockOn: undefined,
    showPassword: false
  }

  capsLockCheck = (e: KeyboardEvent) => this.setState({capsLockOn: e.getModifierState("CapsLock")})

  toggleShowPassword = () => this.setState({showPassword: !this.state.showPassword})

  buildFullSchema = (passwordToMatch: string) => {
    let schema = Validation.string("platform.password.validation.schema.enterPassword")
      .min(8, "platform.password.validation.schema.minCharacters")
      .matches(/[a-z]/, "platform.password.validation.schema.lowercase")
      .matches(/[A-Z]/, "platform.password.validation.schema.uppercase")
      .matches(/[0-9]/, "platform.password.validation.schema.number")

    if (passwordToMatch) {
      schema = schema.oneOf([passwordToMatch], "platform.password.validation.matchPasswords")
    }

    return schema
  }

  buildSchema = () => {
    const {noValidation, isRequired, passwordToMatch} = this.props
    if (noValidation && isRequired) {
      return Validation.string("platform.password.validation.schema.enterPassword")
    }
    return this.buildFullSchema(passwordToMatch)
  }

  render() {
    const {onChange, label, name, value, placeholder, passwordToMatch, noValidation, isRequired, ...props} = this.props
    const {showPassword, capsLockOn} = this.state

    return (
      <>
        <Input
          style={{borderRight: "none"}}
          type={showPassword ? "text" : "password"}
          name={name}
          label={label}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...props}
          validation={this.buildSchema()}
          onKeyDown={this.capsLockCheck}
          onKeyUp={this.capsLockCheck}
          addon={{
            after: (
              <div>
                {capsLockOn && <Icon icon={IconTypes.capsLockOn} marginRight={1} />}
                <IconWrapper onClick={this.toggleShowPassword}>
                  <Icon icon={showPassword ? IconTypes.eyeDisabled : IconTypes.eye} />
                </IconWrapper>
              </div>
            )
          }} />
      </>
    )
  }
}

export default Password
